import React from 'react'
import { Navbar, Nav, Button } from 'react-bootstrap'
import axios from 'axios'
import { GoogleLogout } from 'react-google-login'

import './index.css'

const NavBar = () => {
  const logout = (callback = () => {}) => {
    axios.defaults.headers.common['Authorization'] = ''
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('role')
    window.localStorage.removeItem('googleTokenId')

    callback()
  }

  const authToken = window.localStorage.getItem('token')
  const isAdmin = window.localStorage.getItem('role') === 'ADMIN'

  const renderBtn = (callback) => (
    <Nav.Link href="/">
      <Button
        id="logoutBtn"
        onClick={() => logout(callback)}
        className="ms-3 me-3 fs-6"
      >
        Logout
      </Button>
    </Nav.Link>
  )

  const homeLink = (
    <Nav.Link href="/" className="ms-3 me-3 fs-6">
      Home
    </Nav.Link>
  )

  const privacyPolicy = (
    <Nav.Link href="/privacy-policy" className="ms-3 me-3 fs-6">
      Privacy Policy
    </Nav.Link>
  )

  const honorCode = (
    <Nav.Link
      href="https://kingslanduniversity.com/honour-code/"
      className="ms-3 me-3 fs-6"
    >
      Honour Code
    </Nav.Link>
  )

  const courses = !!authToken && (
    <Nav.Link href="/courses" className="ms-3 me-3 fs-6">
      Courses
    </Nav.Link>
  )

  const loginBtn = !authToken && (
    <Nav.Link href="/login" className="ms-3 me-3 fs-6">
      Login
    </Nav.Link>
  )

  const logoutBtn = !!authToken && (
    <GoogleLogout
      id="logoutBtn"
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      onLogoutSuccess={(e) => console.log(e)}
      onFailure={(e) => console.log(e)}
      render={(renderProps) => renderBtn(renderProps.onClick)}
    />
  )

  const recordings = isAdmin && (
    <Nav.Link href="/recordings" className="ms-3 me-3 fs-6">
      Recordings
    </Nav.Link>
  )

  return (
    <Navbar expand="md" bg="light" className="navbar">
      <Navbar.Brand
        className="d-flex flex-fill justify-content-between align-items-center"
        href="/"
      >
        <img
          id="replayLogo"
          src="/logo.png"
          height="65"
          className="d-inline-block align-top nav-logo"
          alt="Kingsland Replay logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle className="me-4" />
      <Navbar.Collapse id="collapsibleNavbar" className="justify-content-end">
        <Nav className="me-5 align-items-center">
          {homeLink}
          {privacyPolicy}
          {honorCode}
          {courses}
          {recordings}
          {loginBtn}
          {logoutBtn}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default NavBar
